// assets
import {
  ShopOutlined,
  UserOutlined,
  FileTextOutlined,
  ScanOutlined,
  QrcodeOutlined,
  TeamOutlined,
  MailOutlined
} from '@ant-design/icons';

// icons
const icons = {
  ShopOutlined,
  UserOutlined,
  FileTextOutlined,
  ScanOutlined,
  QrcodeOutlined,
  TeamOutlined,
  MailOutlined
};

// ==============================|| MENU ITEMS - MANAGEMENT ||============================== //

const management = {
  id: 'group-management',
  title: 'Gestion',
  type: 'group',
  children: [
    {
      id: 'organizations',
      title: 'Organisations',
      type: 'item',
      url: '/organizations',
      icon: icons.ShopOutlined,
      breadcrumbs: false
    },
    {
      id: 'cashiers',
      title: 'Caissiers',
      type: 'item',
      url: '/cashiers',
      icon: icons.UserOutlined,
      breadcrumbs: false
    },
    {
      id: 'reductions',
      title: 'Réductions',
      type: 'item',
      url: '/reductions',
      icon: icons.FileTextOutlined,
      breadcrumbs: false
    },
    {
      id: 'scan-events',
      title: 'Événements Scan',
      type: 'item',
      url: '/scan-events',
      icon: icons.ScanOutlined,
      breadcrumbs: false
    },
    {
      id: 'emails',
      title: 'Emails',
      type: 'item',
      url: '/emails',
      icon: icons.MailOutlined,
      breadcrumbs: false
    },
    {
      id: 'admins',
      title: 'Administrateurs',
      type: 'item',
      url: '/admins',
      icon: icons.TeamOutlined,
      breadcrumbs: false,
      requireSuperAdmin: true
    }
  ]
};

export default management;
